import React,{useState,useEffect} from "react";
import { refreshNotifications } from "../utils/notifications";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Grid,
  MenuItem,
} from "@mui/material";
import { withRouter } from "../utils/router";
import EnhancedTable from "./enhancedTable";
import VoicemailIcon from "@mui/icons-material/Voicemail";
import GroupsIcon from "@mui/icons-material/GroupsOutlined";
import ListParty from "./listParty";
import WhenText from "./whenText";
import { formatSeconds } from "../utils/format";
import { formatUsPhone, findContactByNumber, contactDisplayName } from "../utils/contacts";
import {
  updateVoicemails,
  updateVoicemailStatus,
  deleteVoicemail,
  forwardVoicemail,
} from "../utils/utils";
import {
  setNotifications,
  setNotificationsLoading,
} from "../store/features/notification/notificationSlice";
import { setCalls } from "../store/features/calls/callSlice";
import { setVoicemails } from "../store/features/voicemails/voicemailSlice";
import { setSmsConversations } from "../store/features/smsConversations/smsConversationsSlice"; 
import { setFaxes } from "../store/features/faxes/faxSlice";
import { setRecordings } from "../store/features/recordings/recordingSlice";
import { setError } from "../store/features/error/errorSlice";
import Forward from "./forward";
import ForwardViaEmail from "./forwardViaEmail";
import { resetSession } from "../store/features/session/sessionSlice";

const mapDispatchToProps = {
  setError,
  setCalls,
  setVoicemails,
  setSmsConversations,
  setFaxes,
  setRecordings,
  setNotifications,
  setNotificationsLoading,
  resetSession,
};

const headCells = (groups) => {
  if (groups) {
    return {
      all: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "duration", numeric: true, disablePadding: false, label: "Duration", },
        { id: "status", numeric: true, disablePadding: false, label: "Status", },
        { id: "received", numeric: true, disablePadding: false, label: "Received", },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions", },
      ],
      new: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "duration", numeric: true, disablePadding: false, label: "Duration", },
        { id: "status", numeric: true, disablePadding: false, label: "Status", },
        { id: "received", numeric: true, disablePadding: false, label: "Received", },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions", },
      ],
      viewed: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "duration", numeric: true, disablePadding: false, label: "Duration" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      urgent: [
        { id: "groupName", numeric: false, disablePadding: false, label: "Group", },
        { id: "duration", numeric: true, disablePadding: false, label: "Duration" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
    };
  }
  else {
    return {
      all: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "duration", numeric: true, disablePadding: false, label: "Duration" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      new: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "duration", numeric: true, disablePadding: false, label: "Duration" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      viewed: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "duration", numeric: true, disablePadding: false, label: "Duration" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
      urgent: [
        { id: "from", numeric: false, disablePadding: false, label: "From", },
        { id: "duration", numeric: true, disablePadding: false, label: "Duration" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "received", numeric: true, disablePadding: false, label: "Received" },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ],
    };
  }
}

const Voicemail = (props) => {
  const {
    title,
    menu,
    menuItems,
    history,
    voicemails,
    session,
    resetSession,
    setVoicemails,
    setSmsConversations,
    setFaxes,
    setRecordings,
    setNotifications,
    setNotificationsLoading,
    setCalling,
    notifications,
    setValue,
    match,
    setError,
    groups,
    personalPhonebook,
  } = props;

  let voicemailTab = match.params.voicemailTab;
  const [page,setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [forward, setForward] = useState(false);
  const [forwardItem, setForwardItem] = useState(null)
  const [email, setEmail] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const [voiceMailFilterGroup, setVoiceMailFilterGroup] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const defaultValues = {
    server: session.lastServer,
    token: session.token,
  };

  const createVoiceMailGroupOptions = () => {
    // Use groupName as name if exists else mailbox
    const voiceMailGroups = [{ key: "", value: "All groups" }];
    const map = new Map();
    for (const item of voicemails) {
      if (item.group.toLowerCase() !== "yes")
        continue;

      if (!map.has(item.mailbox)) {
        map.set(item.mailbox, true);    // set any value to Map
        voiceMailGroups.push({
          key: item.mailbox,
          value: item.groupName !== "" ? item.groupName : item.mailbox
        });
      }
    }
    return voiceMailGroups.map((item) => (
      <MenuItem key={item.key} value={item.key}>{item.value}</MenuItem>
    ));
  }

  const voicemailsFiltered = voicemails.filter((item) => {
    if (!groups) {
      return item.group.toLowerCase() === "no";
    }

    if (voiceMailFilterGroup.toLowerCase() === "")
      return item.group.toLowerCase() === "yes";

    return item.mailbox === voiceMailFilterGroup && item.group.toLowerCase() === "yes";
  })


  // Caller name: the one the server sent, otherwise a personal contact
  // whose number matches.
  const callerName = (item) => {
    const serverName = item.hasOwnProperty("name") ? String(item.name || "").trim() : "";
    return serverName !== ""
      ? serverName
      : contactDisplayName(findContactByNumber([personalPhonebook], item.number));
  };

  const isNew = (item) => String(item.type || "").toLowerCase() === "new";
  const toneOf = (item) => {
    const type = String(item.type || "").toLowerCase();
    return type === "new" ? "brand" : type === "urgent" ? "urgent" : "neutral";
  };

  // Group mailboxes: the group, with who left the message underneath.
  const renderGroupNameCell = (item) => {
    const from = callerName(item) || String(formatUsPhone(item.number) || "");
    return (
      <ListParty
        icon={<GroupsIcon />}
        tone={toneOf(item)}
        title={item.groupName || (item.mailbox ? `Mailbox ${item.mailbox}` : "Group")}
        detail={[
          from !== "" ? `From ${from}` : "",
          item.groupName && item.mailbox ? `Mailbox ${item.mailbox}` : "",
        ].filter(Boolean).join(" · ")}
        isNew={isNew(item)}
        wrap
      />
    );
  };

  // Who left the message, with the number on a second line.
  const renderFromCell = (item) => {
    const name = callerName(item);
    const number = String(formatUsPhone(item.number) || "");
    return (
      <ListParty
        icon={<VoicemailIcon />}
        tone={toneOf(item)}
        title={name !== "" ? name : (number || "Unknown caller")}
        detail={name !== "" ? number : ""}
        isNew={isNew(item)}
      />
    );
  };

  const createRowData = (item) => {
    let obj = {
      from: renderFromCell(item),
      duration: formatSeconds(item.duration),
      status: item.type,
      received: <WhenText dateTime={item.dateTime} />,
      actions: [
        { type: "deleteVM" },
        { type: "email" },
        { type: "forward" },
        { type: "download" },
        { type: "call" },
        { type: "play" },
      ],
      object: item,
    };

    if (groups) {
      // The group cell also says who called, so there is no From column.
      const { from, ...rest } = obj;
      obj = { groupName: renderGroupNameCell(item), ...rest };
    }

    return obj; 
  }

  // Search: a caller's name, a group, or a number typed any way.
  const term = searchTerm.trim().toLowerCase();
  const termDigits = /^[\d\s()+.-]+$/.test(term) ? term.replace(/\D/g, "") : "";
  const matchesSearch = (item) => {
    if (term.length < 2) return true;
    if (callerName(item).toLowerCase().includes(term)) return true;
    if (groups && String(item.groupName || "").toLowerCase().includes(term)) return true;
    const number = String(item.number || "");
    if (number.toLowerCase().includes(term)) return true;
    if (termDigits.length < 2) return false;
    const digits = number.replace(/\D/g, "");
    return digits.includes(termDigits) ||
      (termDigits.length > 2 && termDigits[0] === "1" && digits.includes(termDigits.slice(1)));
  };

  // Which voicemails a tab shows.
  const inTab = (item, tab) => {
    const type = String(item.type || "").toLowerCase();
    switch (tab) {
      case "new":
        return type === "new";
      case "viewed":
        return type === "old";
      case "urgent":
        return type === "urgent";
      case "all":
        return item.type !== "deleted";
      default:
        return false;
    }
  };

  const generateRows = ()=>{
    return voicemailsFiltered
      .filter((item) => inTab(item, voicemailTab) && matchesSearch(item))
      .map((item) => createRowData(item));
  }

  // The New and Urgent tabs say how many voicemails wait in them.
  const menuWithCounts = (menuItems || []).map((item) => (
    item.linkId === "new" || item.linkId === "urgent"
      ? { ...item, count: voicemailsFiltered.filter((voicemail) => inTab(voicemail, item.linkId)).length }
      : item
  ));

  const refetchNotifications = () => refreshNotifications({
    values: defaultValues,
    setters: { setCalls, setFaxes, setRecordings, setVoicemails, setSmsConversations },
    setNotifications,
    setNotificationsLoading,
    onUnauthorized: () => {
      resetSession();
      history.push('/login');
    },
  });

  const clearCurrentNotifications = () =>{
    let values = defaultValues;

    values.voicemail = voicemails
      .filter(
        (voicemail) =>
          ( voicemail.viewed !== "yes" && 
            voicemail.type.toLowerCase() === voicemailTab.toLowerCase() ) ||
          ( voicemail.viewed !== "yes" && 
            voicemailTab.toLowerCase() === "viewed" &&
            voicemail.type.toLowerCase() === "old" )
      )
      .map((voicemail) => {
        return {
          vid: voicemail.vid,
          viewed: "yes",
          type: voicemail.type,
        };
      });
    try {
      updateVoicemails(values);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    clearCurrentNotifications();
    // eslint-disable-next-line
  }, [voicemailTab, title]);

  const handleStatusChange = async (type,item) => {
    let voicemailType = type.toLowerCase() === "viewed" ? "old" : type.toLowerCase();
    try {
      await updateVoicemailStatus(defaultValues, item.vid, voicemailType);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  const handleDelete = (items) => {
    let values = defaultValues;

    values.voicemail = items.map((item) =>
      item.hasOwnProperty("object")
        ? {
            vid: item.object.vid,
            title: item.object.title,
            viewed: "yes",
            type: "deleted",
          }
        : {
            vid: item.vid,
            title: item.title,
            viewed: "yes",
            type: "deleted",
          }
    );

    try {
      updateVoicemails(values);
      refetchNotifications();
    } catch (error) {
      console.error(error);
    }
  }

  const handleDeleteForever = (item) => {
    let values = defaultValues;
    values.id = item.vid

    try {
      deleteVoicemail(values);
      setError({
        visible: true,
        type: "success",
        message: "Successfully deleted Item",
      });
      refetchNotifications();
    } catch (error) {
      setError({
        visible: true,
        type: "error",
        message: error,
      });
      console.error(error);
    }
  }

  return (
    <Grid container>
      <Grid size={12}>
        <ForwardViaEmail
          open={email}
          setOpen={setEmail}
          file={attachment}
          type="Voicemail"
          defaultValues={defaultValues}
        />
        <Forward
          open={forward}
          setOpen={setForward}
          value={forwardItem}
          type="Voicemail"
          forwardFunction={forwardVoicemail}
          idKey="vid"
          defaultValues={defaultValues}
        />
        <EnhancedTable
          setError={setError}
          type="voicemail"
          headerData={headCells(groups)}
          rowData={generateRows()}
          dense={false}
          hasActions={true}
          selectable={false}
          menu={menu ? menuWithCounts : false}
          searchFunc={(value) => { setSearchTerm(value); setPage(0); }}
          title={title}
          tab={voicemailTab}
          history={history}
          hasClear={false}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
          handleDialClick={null}
          setCalling={setCalling}
          setValue={setValue}
          setForwardItem={setForwardItem}
          setForward={setForward}
          loading={notifications.loading}
          statusChangeFunction={handleStatusChange}
          handleDelete={handleDelete}
          handleDeleteForever={handleDeleteForever}
          setAttachment={setAttachment}
          setSendEmail={setEmail}
          useGroupFilter={groups}
          createGroupOptions={createVoiceMailGroupOptions}
          filterGroup={voiceMailFilterGroup}
          setFilterGroup={setVoiceMailFilterGroup}
          statusOptions={["New", "Viewed", "Urgent"]}
          refreshDataOnSameTab={clearCurrentNotifications}
        />
      </Grid>
    </Grid>
  );
};

Voicemail.propTypes = {
  title: PropTypes.string.isRequired,
  menu: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      linkId: PropTypes.string,
    })
  ),
  tab: PropTypes.string.isRequired,
  handleDialClick: PropTypes.func.isRequired,
  setCalling: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  groups: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    voicemails: state.voicemails,
    notifications: state.notifications,
    personalPhonebook: state.personalPhonebook,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Voicemail)
);